export default "__VITE_ASSET__DDBbYMIe__"